module.exports = __webpack_public_path__ + "static/media/sms-credit.04b0c2df.svg";